import React from 'react'
import './style.scss';
import { Loaderimg } from '../../appconfig';
const Loader = () => {
  return (
    <div className='loader-container '>
        <img src={Loaderimg} />
    </div>
  )
}

export default Loader